var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_028-clipboard",
    "data-name": "028-clipboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.069,
    height: 65.983,
    viewBox: "0 0 52.069 65.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7278",
    "data-name": "Group 7278",
    transform: "translate(5.728 5.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17221",
    "data-name": "Path 17221",
    d: "M139.047,48.472a4.054,4.054,0,0,0-4.05-4.05H123.462a1.289,1.289,0,1,0,0,2.577H135a1.474,1.474,0,0,1,1.472,1.472V88.7h-6.394a1.289,1.289,0,0,0-1.289,1.289v6.394h-26.3a1.474,1.474,0,0,1-1.472-1.472V48.472A1.474,1.474,0,0,1,102.484,47h11.79a1.289,1.289,0,1,0,0-2.577h-11.79a4.054,4.054,0,0,0-4.05,4.05V94.906a4.054,4.054,0,0,0,4.05,4.049H135a4.054,4.054,0,0,0,4.05-4.049Zm-7.683,42.8h3.282l-3.282,3.282Zm3.633,5.1h-1.81L136.47,93.1v1.81A1.474,1.474,0,0,1,135,96.378Z",
    transform: "translate(-98.434 -44.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17222",
    "data-name": "Path 17222",
    d: "M168.041,130.619l-3.429,6.13h-3.291a1.289,1.289,0,0,0,0,2.577h4.047a1.289,1.289,0,0,0,1.125-.66l2.195-3.923,2.144,8.845a1.289,1.289,0,0,0,2.319.419l3.6-5.315.781,1.529a1.288,1.288,0,0,0,1.133.7l4.8.055a1.289,1.289,0,0,0,.03-2.577l-4.018-.046-1.418-2.777a1.289,1.289,0,0,0-2.215-.137l-3.193,4.709-2.232-9.208a1.289,1.289,0,0,0-2.377-.325Z",
    transform: "translate(-152.094 -118.936)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7284",
    "data-name": "Group 7284",
    transform: "translate(15.125 1.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7283",
    "data-name": "Group 7283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7282",
    "data-name": "Group 7282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7281",
    "data-name": "Group 7281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7280",
    "data-name": "Group 7280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7279",
    "data-name": "Group 7279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17223",
    "data-name": "Path 17223",
    d: "M171.35,10v2.086a8.011,8.011,0,0,0,8.011,8.01h5.8a8.01,8.01,0,0,0,8.011-8.01V10Z",
    transform: "translate(-171.35 -10)",
    fill: "#00acb1"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7289",
    "data-name": "Group 7289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7287",
    "data-name": "Group 7287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7286",
    "data-name": "Group 7286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7285",
    "data-name": "Group 7285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17224",
    "data-name": "Path 17224",
    d: "M99.487,65.983H60.56a6.578,6.578,0,0,1-6.571-6.57V6.57A6.578,6.578,0,0,1,60.56,0H99.487a6.578,6.578,0,0,1,6.571,6.57V59.413A6.578,6.578,0,0,1,99.487,65.983ZM60.56,2.577A4,4,0,0,0,56.567,6.57V59.413a4,4,0,0,0,3.993,3.993H99.487a4,4,0,0,0,3.993-3.993V6.57a4,4,0,0,0-3.993-3.993Z",
    transform: "translate(-53.989 0)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7297",
    "data-name": "Group 7297",
    transform: "translate(17.921 35.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17225",
    "data-name": "Path 17225",
    d: "M204.716,273.595a3.67,3.67,0,0,0-3.454,1.886.127.127,0,0,1-.222,0,3.657,3.657,0,0,0-3.447-1.886,4.4,4.4,0,0,0-4.55,4.658,6.308,6.308,0,0,0,.939,3.426c1.408,2.373,6.044,4.329,7,4.935a.32.32,0,0,0,.344,0c.953-.6,5.591-2.544,7.009-4.936a6.3,6.3,0,0,0,.938-3.426A4.4,4.4,0,0,0,204.716,273.595Z",
    transform: "translate(-193.042 -273.595)",
    fill: "#00acb1"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/asset-10.11653cbe6aba81e3be358121cb442849.svg";
export { ForwardRef as ReactComponent };